/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, createServiceProviderSettingsFromDiscriminatorValue, type ProblemDetails, type ServiceProviderSettings } from '../models/index.js';
// @ts-ignore
import { AddressRequestBuilderRequestsMetadata, type AddressRequestBuilder } from './address/index.js';
// @ts-ignore
import { AuditentriesRequestBuilderRequestsMetadata, type AuditentriesRequestBuilder } from './auditentries/index.js';
// @ts-ignore
import { BankAccountRequestBuilderRequestsMetadata, type BankAccountRequestBuilder } from './bankAccount/index.js';
// @ts-ignore
import { CompanyRegistrationRequestBuilderRequestsMetadata, type CompanyRegistrationRequestBuilder } from './companyRegistration/index.js';
// @ts-ignore
import { ContactRequestBuilderRequestsMetadata, type ContactRequestBuilder } from './contact/index.js';
// @ts-ignore
import { PayoutDetailsRequestBuilderRequestsMetadata, type PayoutDetailsRequestBuilder } from './payoutDetails/index.js';
// @ts-ignore
import { SupportEmailRequestBuilderRequestsMetadata, type SupportEmailRequestBuilder } from './supportEmail/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /serviceprovidersettings
 */
export interface ServiceprovidersettingsRequestBuilder extends BaseRequestBuilder<ServiceprovidersettingsRequestBuilder> {
    /**
     * The address property
     */
    get address(): AddressRequestBuilder;
    /**
     * The auditentries property
     */
    get auditentries(): AuditentriesRequestBuilder;
    /**
     * The bankAccount property
     */
    get bankAccount(): BankAccountRequestBuilder;
    /**
     * The companyRegistration property
     */
    get companyRegistration(): CompanyRegistrationRequestBuilder;
    /**
     * The contact property
     */
    get contact(): ContactRequestBuilder;
    /**
     * The payoutDetails property
     */
    get payoutDetails(): PayoutDetailsRequestBuilder;
    /**
     * The supportEmail property
     */
    get supportEmail(): SupportEmailRequestBuilder;
    /**
     * GetServiceProviderSettings
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ServiceProviderSettings>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ServiceProviderSettings | undefined>;
    /**
     * GetServiceProviderSettings
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ServiceprovidersettingsRequestBuilderUriTemplate = "{+baseurl}/serviceprovidersettings";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ServiceprovidersettingsRequestBuilderNavigationMetadata: Record<Exclude<keyof ServiceprovidersettingsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    address: {
        requestsMetadata: AddressRequestBuilderRequestsMetadata,
    },
    auditentries: {
        requestsMetadata: AuditentriesRequestBuilderRequestsMetadata,
    },
    bankAccount: {
        requestsMetadata: BankAccountRequestBuilderRequestsMetadata,
    },
    companyRegistration: {
        requestsMetadata: CompanyRegistrationRequestBuilderRequestsMetadata,
    },
    contact: {
        requestsMetadata: ContactRequestBuilderRequestsMetadata,
    },
    payoutDetails: {
        requestsMetadata: PayoutDetailsRequestBuilderRequestsMetadata,
    },
    supportEmail: {
        requestsMetadata: SupportEmailRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ServiceprovidersettingsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ServiceprovidersettingsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createServiceProviderSettingsFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
